import { Injectable } from '@angular/core';
import { CommonService } from '../shared/utils/common.service';
import { UtilsService } from '../shared/utils/utils.service';
import { url } from '../../assets/data/diccionario.js';
import { Observable } from 'rxjs';
import { TipoMaterial } from '../model/datos-maestros/tipoMaterialModel';
import { ClaveValorModel } from '../aplicaciones-modulos/portal-compras/model/claveValorModel';
import { MaterialModel } from '../aplicaciones-modulos/portal-compras/model/materialModel';
import { GrupoArticuloModel } from '../aplicaciones-modulos/portal-compras/model/grupoArticuloModel';
import { Frecuencia } from '../model/datos-maestros/frecuencia';
import { TipoPago } from '../model/datos-maestros/tipoPago';
import { ViaPago } from '../model/datos-maestros/viaPago';
import { CondicionPago } from '../model/datos-maestros/condicionPago';
import { AngenciasModel } from '../aplicaciones-modulos/sustentos/models/agenciasModel';
import { Cliente, devMotivo, devTipoPago, Vendedor } from '../model/shorts';
import { MaterialPresentacion } from '../model/datos-maestros/materialPresentacion';
import { Placa } from '../model/datos-maestros/placa';
import { ProveedorModel } from '../aplicaciones-modulos/portal-compras/model/proveedorModel';
import { Chofer } from '../aplicaciones-modulos/traslado-logist/model/model';
import { IAlmacen } from '../model/datos-maestros/dmaestrosModel';
import { Pagination } from '../model/interfaces/pagination';
import { ClienteShortResponse } from '../model/datos-maestros/cliente-short';

@Injectable({
  providedIn: 'root'
})
export class DatosMaestrosService {

  url: string;
  diccionarioUrl: any = {};

  constructor(private _commom: CommonService,
    private _util: UtilsService) {
    this.url = this._util.getDatosMaestros();
    this.diccionarioUrl = url.datosMaestrosSap;
  }

  // *OBTIENE TODAS LAS OFICINAS VENTAS EXISTENTES
  getAllOficinasVentas(): Observable<AngenciasModel[]> {
    return this._commom.peticionGetConHeader(this.url + this.diccionarioUrl.oficinaventa);
  }

  // *OBTIENE TODAS LAS EMPRESAS EXISTENTES
  getAllEmpresas() {
    return this._commom.peticionGetConHeader(this.url + this.diccionarioUrl.empresa);
  }

  // *OBTIENE LOS BANCOS RELACIONADOS A LA EMPRESA
  getBancoPorEmpresa(inIdEmpresa: string) {
    return this._commom.peticionGetConHeader(this.url + this.diccionarioUrl.banco + inIdEmpresa);
  }

  getAllBancoActivos() {
    return this._commom.peticionGetConHeader(this.url + this.diccionarioUrl.bancoActivos);
  }

  getAllTipoPago() {
    return this._commom.peticionGetConHeader(this.url + this.diccionarioUrl.tipoPago);
  }

  getAllTipoPagoForDevoluciones(): Observable<TipoPago[]> {
    return this._commom.peticionGetConHeader(`${this.url}${this.diccionarioUrl.tipoPago}/devolucion`);
  }

  getAllTipoPagoShort(): Observable<TipoPago[]> {
    return this._commom.peticionGetConHeader(`${this.url}${this.diccionarioUrl.tipoPago}/short`);
  }

  // *OBTIENE LAS CUENTAS RELACIONADAS A LOS BANCOS
  getCuentaPorBanco(inIdEmpresa: string, inIdBanco: string) {
    return this._commom.peticionGetConHeader(this.url + this.diccionarioUrl.bancoCuenta + `${inIdEmpresa}/${inIdBanco}`);
  }

  // *OBTIENE TODOS LOS DOCUMENTO
  getAllDoc() {
    return this._commom.peticionGetConHeader(this.url + this.diccionarioUrl.documento);
  }

  // !FALTA REVISAR
  getFechaFacbril(fecha: string) {
    return this._commom.peticionGetConHeader(this.url + this.diccionarioUrl.fechaFabril + "diaria?fecha=" + fecha);
  }

  // !FALTA REVISAR
  getVendedorAgencia(oficina: string) {
    return this._commom.peticionGetConHeader(this.url + this.diccionarioUrl.vendedorAge + oficina);
  }

  // *PORTAL DE COMPRAS
  getAllTipoMaterial(): Observable<TipoMaterial[]> {
    return this._commom.peticionGetConHeader(this.url + this.diccionarioUrl.tipoMaterial + '/portal-compra');
  }

  getTipoMaterialByBienServicio(tipo: number): Observable<TipoMaterial[]> {
    return this._commom.peticionGetConHeader(this.url + this.diccionarioUrl.tipoMaterial + `/portal-compra/tipoMaterial/${tipo}`);
  }

  getIva(): Observable<any[]> {
    return this._commom.peticionGetConHeader(this.url + this.diccionarioUrl.indicadorIva);
  }

  getIndicadorIvaActivoFijo(innTipoSolicitud: string): Observable<any[]> {
    return this._commom.peticionGetConHeader(this.url + this.diccionarioUrl.indicadorIvaActivoFijo + `/${innTipoSolicitud}`);
  }

  getIndicadorIvaValidos(fecha: string): Observable<any[]> {
    return this._commom.peticionGetConHeader(this.url + this.diccionarioUrl.indicadorIvaValidos + `/${fecha}`);
  }

  getAllCentroLogistico() {
    return this._commom.peticionGetConHeader(this.url + this.diccionarioUrl.centroLogistico);
  }
  getAllOrganizacionVenta() {
    return this._commom.peticionGetConHeader(this.url + this.diccionarioUrl.organizacionVenta);
  }
  getAllCanalVenta() {
    return this._commom.peticionGetConHeader(this.url + this.diccionarioUrl.canalVenta);
  }
  getAllSectorVenta() {
    return this._commom.peticionGetConHeader(this.url + this.diccionarioUrl.sectorVenta);
  }
  getAllCuentaContable() {
    return this._commom.peticionGetConHeader(this.url + this.diccionarioUrl.cuentaContable);
  }
  getAllMotivoPedido() {
    return this._commom.peticionGetConHeader(this.url + this.diccionarioUrl.motivoPedido);
  }
  getAllUnidadMedida() {
    return this._commom.peticionGetConHeader(this.url + this.diccionarioUrl.unidadMedida);
  }
  getMaterialPresentacionByMaterial(payload) {
    return this._commom.peticionGetConHeader(this.url + this.diccionarioUrl.materialPresentacion + '/' +  payload + '/' +'disp-venta');
  }
  getPrecioByQueryParams(payload) {
    return this._commom.peticionGetConHeader(this.url + this.diccionarioUrl.precioByQueryParams + '/' +  payload.idOrgaVenta + '/' +  payload.idCanalVenta + '/'+  payload.idGrupoCliente + '/'+  payload.idOficinaVenta + '/'+  payload.idCliente + '/'+  payload.idMaterial + '/' +  payload.idUnidad);
  }
  getAllTipoImputacion() {
    return this._commom.peticionGetConHeader(this.url + this.diccionarioUrl.tipoImputacion);
  }
  getClienteVentaAmpliadoPorPKClientePKOrgaVentaPKCanalVentaPKSectorVenta(payload): Observable<any> {
    return this._commom.peticionGetConHeader(this.url + this.diccionarioUrl.grupoVendedor + '/' + payload.data.idCliente + '/'+payload.data.idOrgaVenta + '/'+payload.data.idCanalVenta + '/'+payload.data.idSectorVenta);
    //return this._commom.peticionGetConHeader('http://localhost:8084/dmaestros-api/v1/api/services/grupo-vendedor' + '/' + payload.data.idCliente + '/'+payload.data.idOrgaVenta + '/'+payload.data.idCanalVenta + '/'+payload.data.idSectorVenta);
  }

  getAllAlmacen() {
    return this._commom.peticionGetConHeader(this.url + this.diccionarioUrl.almacen);
  }

  getAllAlmacenByCentro(idCentro: string): Observable<IAlmacen[]>{
    return this._commom.peticionGetConHeader(this.url + this.diccionarioUrl.almacen + `/byCentro/${idCentro}`);
  }

  getAllMaterialGrupoByTipoMat(innIdTipoMaterial: string): Observable<GrupoArticuloModel[]> {
    return this._commom.peticionGetConHeader(this.url + this.diccionarioUrl.grupoArticulo + `/${innIdTipoMaterial}`);
  }
  getAllGrupoVendedor(): Observable<any> {
    return this._commom.peticionGetConHeader(this.url + this.diccionarioUrl.grupoVendedor);
  }
  getAllSimpleCondicionPago(): Observable<any> {
    return this._commom.peticionGetConHeader(this.url + this.diccionarioUrl.condicionPago);
  }
  getAllOnlyClasePedido(): Observable<any> {
    return this._commom.peticionGetConHeader(this.url + this.diccionarioUrl.onlyClasePedido);
  }
  getAllClasePedido(): Observable<any> {
    return this._commom.peticionGetConHeader(this.url + this.diccionarioUrl.clasePedido);
  }
  getAllCondicionExpedicion(): Observable<any> {
    return this._commom.peticionGetConHeader(this.url + this.diccionarioUrl.condicionExpedicion);
  }
  getAllElementoPEP(): Observable<any> {
    return this._commom.peticionGetConHeader(this.url + this.diccionarioUrl.elementoPEP);
  }
  getAllOrdenInternaDmaestros(): Observable<any> {
    return this._commom.peticionGetConHeader(this.url + this.diccionarioUrl.ordenInterna);
  }
  getAllCentroCostos(): Observable<any> {
    return this._commom.peticionGetConHeader(this.url + this.diccionarioUrl.centroCosto);
  }

  getAllFrecuencias(): Observable<Frecuencia[]> {
    return this._commom.peticionGetConHeader(`${this.url}/frecuencia`)
  }

  getAllViaPago(): Observable<ViaPago[]> {
    return this._commom.peticionGetConHeader(`${this.url}/via-pago`);
  }

  getAllCondicionPago(): Observable<CondicionPago[]> {
    return this._commom.peticionGetConHeader(`${this.url}/condicion-pago?short=true`);
  }

  getAllSellersByOffice(office: string, role: string = ''): Observable<Vendedor[]> {
    return this._commom.peticionGetConHeader(`${this.url}/vendedor/short?idOficinaVenta=${office}&idRol=${role}`)
  }

  getSupervisoresByOffice(office: string) : Observable<Cliente[]> {
    return this._commom.peticionGetConHeader(`${this.url}/cliente/supervisores/agencia?vendedores=true&idOficinaVenta=${office}`)
  }

  getAllSellersBySupervisor(supervisor: string, role: string = ''): Observable<Vendedor[]> {
    return this._commom.peticionGetConHeader(`${this.url}/vendedor/short?supervisor=${supervisor}&idRol=${role}`)
  }

  getSupervisores() : Observable<Cliente[]> {
    return this._commom.peticionGetConHeader(`${this.url}/cliente/supervisores?vendedores=true`)
  }

  getClientsVda(vda: string) : Observable<Cliente[]> {
    return this._commom.peticionGetConHeader(`${this.url}/cliente/short?idVda=${vda}`)
  }

  // BUSQUEDA CLIENTE
  searchClientes(query: string, type: 'nombre' | 'ruc', pagination: Pagination): Observable<ClienteShortResponse> {
    let params = `page=${pagination.page}&pageSize=${pagination.pageSize}`;
    if (type === 'nombre') {
      params += `&nombreCliente1=${query}`;
    } else {
      params += `&ruc=${query}`;
    }
    // Aseguramos que el endpoint sea el correcto
    return this._commom.peticionGetConHeaderSinMapeo(`${this.url}cliente/search?${params}`);
  }

  // BUSQUEDA PROVEEDOR
  searchProveedor(query: string, type: 'nombre' | 'ruc', pagination: Pagination): Observable<any> {
    let params = `page=${pagination.page}&pageSize=${pagination.pageSize}&orderDesc=true`;
    if (type === 'nombre') {
      params += `&nombre=${query}`;
    } else {
      params += `&ruc=${query}`;
    }
    return this._commom.peticionGetConHeaderSinMapeo(`${this.url}proveedor/search?${params}`);
  }

  getMaterialPresentacion(idMaterial: number): Observable<MaterialPresentacion[]> {
    return this._commom.peticionGetConHeader(`${this.url}/material-presentacion/buscar?idMaterial=${idMaterial}`);
  }

  // getAllMaterialByTipoGrupo(innIdTipoMaterial: string, innIdGrupoMaterial: string): Observable<MaterialModel[]> {
  //   return this._commom.peticionGetConHeader(this.url + this.diccionarioUrl.material + `/${innIdTipoMaterial}/${innIdGrupoMaterial}`)
  // }

  // getAllMaterialByTipoGrupoBienServicio(innIdTipoMaterial: string, innIdGrupoMaterial: string, tipo: string): Observable<MaterialModel[]> {
  //   return this._commom.peticionGetConHeader(this.url + this.diccionarioUrl.material + `/materiales/${innIdTipoMaterial}/${innIdGrupoMaterial}/${tipo}`)
  // }

  getAllTiers(){
    return this._commom.peticionGetConHeader(this.url + this.diccionarioUrl.tiers);
  }

  // CA-SD33-REPORTES VENTAS
  getSeguimientoCartera(param: string){
    return this._commom.peticionGetConHeader(this.url + "cliente/seguimiento/cartera?" + param);
  }

  getSeguimientoRuta(param: string){
    return this._commom.peticionGetConHeader(this.url + "cliente/seguimiento/ruta?" + param);
  }

  getSeguimientoVentas(param: string){
    return this._commom.peticionGetConHeader(this.url + "cliente/seguimiento/ventas?" + param);
  }

  getVendedorBySupervisor(supervisor: string, role: string = ''){
    return this._commom.peticionGetConHeader(`${this.url}vendedor/short?supervisor=${supervisor}&idRol=${role}`);
  }

  getVendedorByGrupo(grupoVendedor: string, role: string = ''){
    return this._commom.peticionGetConHeader(`${this.url}vendedor/short?grupoVendedor=${grupoVendedor}&idRol=${role}`);
  }

  // TICKET 1226 - Puntos a definir en las devoluciones SAP (sugerencias)- Alto
  getDevtipoPago(): Observable<devTipoPago[]> {
    return this._commom.peticionGetConHeader(this.url + "tipo-pago/devolucion");
  }

  getDevMotivo(tipoPedido: number): Observable<devMotivo[]> {
    return this._commom.peticionGetConHeader(this.url + "motivo-devolucion/tipo-pago/" + tipoPedido);
  }

  getClienteId(idCliente: string): Observable<any> {
    return this._commom.peticionGetConHeader(this.url + "cliente/" + idCliente);
  }

  getMaterialxId(codMaterial: string): Observable<any> {
    return this._commom.peticionGetConHeader(this.url + "material/" + codMaterial);
  }

  // RTI-TICKET 14038 CONTROL DE CAMBIO DE BALANZA
  getPlacabyProvedor(idProveedor: string): Observable<Placa[]> {
    return this._commom.peticionGetConHeader(this.url + "placa/proveedor/"+idProveedor);
  }

  getPlacabyId(placa: string): Observable<Placa> {
    return this._commom.peticionGetConHeader(this.url + "placa/"+placa);
  }

  getValidaClienteCartera(idCliente: any) {
    return this._commom.peticionGetConHeader(this.url + "cliente/cartera/"+idCliente);
  }

  // RTI-TICKET COMBOS ESSENCIAL
  getAllUnidadNegocio(): Observable<any> {
    return this._commom.peticionGetConHeader(this.url + this.diccionarioUrl.unidadNegocio);
  }

  getAllCanalVendedor(): Observable<any> {
    return this._commom.peticionGetConHeader(this.url + this.diccionarioUrl.canalVendedor);
  }

  getAllTarifaCanal(): Observable<any> {
    return this._commom.peticionGetConHeader(this.url + this.diccionarioUrl.tarifaCanal);
  }

  getAllGrupoCliente(): Observable<any> {
    return this._commom.peticionGetConHeader(this.url + this.diccionarioUrl.grupoCliente);
  }

  getAllGrupoTarifaCanal(): Observable<any> {
    return this._commom.peticionGetConHeader(this.url + this.diccionarioUrl.grupoTarifaCanal);
  }

  // PRESUPUESTO-COMERCIAL Y COMISIONES TICKET # 7729 | Requerimiento: CA-SD-43
  getAllSubCategorias(): Observable<any> {
    return this._commom.peticionGetConHeader(this.url + "/subcategoria");
  }

  // T.22880 Mejoras en proceso CLOROX recompra
  getAllCentroLogisticoRecompra() {
    return this._commom.peticionGetConHeader(this.url + this.diccionarioUrl.centroLogistico+"/recompra");
  }

  //T.14473 CPD Forzado
  getAllNodos() {
    return this._commom.peticionGetConHeader(this.url +  "/nodo/alltipos");
  }

  getMaterialPresentacionAllPresentacionesxMaterial(idMaterial: number): Observable<MaterialPresentacion[]> {
    let url = `${this.url}/material-presentacion/${idMaterial}/presentaciones`;
    return this._commom.peticionGetConHeader(url);
  }
  //end

  getProveedorByID(idProveedor: number):  Observable<any>{
    let url = `${this.url}proveedor/${idProveedor}`;
    return this._commom.peticionGetConHeader(url);
  }

  getChoferByCedula(cedula: string): Observable<Chofer>{
    let url = `${this.url}chofer/cedula/${cedula}`;
    return this._commom.peticionGetConHeader(url);
  }

  getFurgonByRecurso(idRecurso: string): Observable<Placa[]>{
    let url = `${this.url}placa/furgon/${idRecurso}`;
    return this._commom.peticionGetConHeader(url);
  }

  getChoferSearchNombres(nombres: string, proveedor: string = null): Observable<Chofer[]>{
    let url = `${this.url}chofer/search?nombres=${nombres}`;
    if(proveedor) url = url.concat(`&proveedor=${proveedor}`);    
    return this._commom.peticionGetConHeader(url);
  }

  getTransportesByRecurso(idRecurso: string): Observable<any[]>{
    let url = `${this.url}placa/tipoTransporte/${idRecurso}`;
    return this._commom.peticionGetConHeader(url);
  }

  //T# 37021 medición iniciativas 
  getAllZonaVentas(): Observable<any> {
    return this._commom.peticionGetConHeader(this.url + "/zona-trasporte");
  }

  getAllZonaVentasVdi(): Observable<any> {
    return this._commom.peticionGetConHeader(this.url + "/zona-trasporte/vdi");
  }

  getAllDiasVisista(): Observable<any> {
    return this._commom.peticionGetConHeader(this.url + "/dia-visita");
  }

  getAllDiasVisistaVDI(): Observable<any> {
    return this._commom.peticionGetConHeader(this.url + "/dia-visita/all/vdi");
  }
  
  //end


}
